<template>
  <div class="d-flex flex-column min-vh-100 bg-light2">
    <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
      <div class="shadow-lg  rounded-4 bg-white p-3 p-sm-5 h-50" style="width: 450px !important; max-width: 90vw !important;">
        <div class="text-center mb-4">
          <img
            :src="logo"
            alt="Logo de l'événement"
            class="img-fluid mb-5 mt-3"
            style="max-width: 180px;"
          />
        </div>

        <form novalidate v-if="loginMode === 'password'" @submit.prevent="loggin('password')">
          <TextInputComponent
              class="mb-3"
              label="Email"
              type="email"
              id="email"
              placeholder="Email"
              value-key="login"
              :required="true"
              :validate-on-value-update="false"
              :validate-on-blur="true"
              :disabled="isSubmitting || codeSent"
              @input="() => { codeSent = false; currentLogin = undefined }"
            />
            <TextInputComponent
              label="Mot de passe"
              type="password"
              placeholder="Mot de passe"
              value-key="password"
              :required="true"
              class="mb-3"
              :disabled="isSubmitting"
            />
            <div class="d-grid mt-2">
              <button class="btn btn-primary" :disabled="isSubmitting">
                <span
                  v-if="isSubmitting"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Se Connecter
              </button>
            </div>

            <div class="text-center mt-3 mb-4">
              <small class="text-muted">
                <a href="#" class="text-decoration-none text-muted" @click.prevent="changeMode('code')">
                  Connexion sans mot de passe ? Cliquez ici
                </a>
              </small>
            </div>
        </form>
        <form novalidate v-else-if="loginMode == 'link'" @submit.prevent="sendLink">
          <TextInputComponent
              class="mb-3"
              label="Email"
              type="email"
              id="email"
              placeholder="Email"
              value-key="login"
              :required="true"
              :validate-on-value-update="false"
              :validate-on-blur="true"
              :disabled="isSubmitting"
              @input="() => { codeSent = false; currentLogin = undefined }"
            />
          <div class="d-grid mt-2">
            <button @click.prevent="sendLink" class="btn btn-primary" :disabled="isSubmitting || codeSent">
              <span
                v-if="isSubmitting"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Recevoir un lien de connexion par Email
            </button>

            <div class="text-center mt-3 mb-4">
            <small class="text-muted">
              <a href="#" class="text-decoration-none text-muted" @click.prevent="changeMode('password')">
                Connexion avec un mot de passe ? Cliquez ici
              </a>
            </small>
          </div>
          </div>
        </form>
        <div v-else-if="loginMode == 'code'">
            <TextInputComponent
              class="mb-3"
              label="Email ou Téléphone"
              type="text"
              id="email"
              placeholder="Email ou Téléphone"
              value-key="login"
              :required="true"
              :validate-on-value-update="false"
              :validate-on-blur="true"
              :disabled="isSubmitting"
              @input="() => { codeSent = false; currentLogin = undefined }"
            />

          <div class="d-grid mt-2">
            <NumberInputComponent
              ref="code-input"
              v-if="codeSent"
              value-key="code"
              class="mb-3"
              input-class="text-center form-control-lg letter-spacing-20-px input-number-clear-arrows"
              label="Entrez le code de connexion reçu"
              placeholder="Entrez le code de connexion reçu par email"
              :required="false"
              :disabled="isSubmitting"
              @input="() => { if((formValues.code??0) > 999 && (formValues.code??0) < 10000) { loggin('code') } }"
            />
            <button v-if="!codeSent && !currentLogin" class="btn btn-primary text-nowrap" :disabled="isSubmitting" @click="() => { currentLogin = formValues.login; checkCanLogBySMS(); checkCanLogByEmail() }">
              <span
                v-if="isSubmitting"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Suivant<i class="fa-solid fa-arrow-right ms-2"></i>
            </button>
            <div v-else-if="!codeSent && (canLogBySMS || canLogByEmail)">
              <div class="text-center">Recevoir un code de connexion par</div>
              <div class="text-center">
                <button v-if="canLogByEmail" class="btn btn-primary me-3" :disabled="isSubmitting" @click="sendEmail">
                  Email
                </button>
                <button v-if="canLogBySMS" class="btn btn-primary" :disabled="isSubmitting" @click="sendSMS">
                  SMS
                </button>
              </div>
            </div>
            <button v-else-if="!codeSent" class="btn btn-primary" :disabled="isSubmitting" @click="sendEmail">
              <span
                v-if="isSubmitting"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Recevoir un code de connexion par Email
            </button>
            <template v-else>
              <button class="btn btn-primary" :disabled="isSubmitting">
                <span
                  v-if="isSubmitting"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Se connecter
              </button>
              <button v-if="canLogByEmail" @click.prevent="codeSent=false; sendEmail();" class="btn btn-link btn-sm mt-2" :disabled="isSubmitting">
                <span
                  v-if="isSubmitting"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Recevoir un nouveau code de connexion
              </button>
            </template>
          </div>
          <div class="text-center mt-3 mb-4">
            <small class="text-muted">
              <a href="#" class="text-decoration-none text-muted" @click.prevent="changeMode('password')">
                Connexion avec un mot de passe ? Cliquez ici
              </a>
            </small>
          </div>
        </div>
      </div>
    </div>

    <FooterComponent class="mt-auto" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed, useTemplateRef } from 'vue'
import defaultLogo from '@/assets/logo.png'
import blankHomeLogo from '@/assets/blank-home-logo.png'

import userApi from '@/api/userApi'
import travelApi from '@/api/travelApi'
import { getPictureUrl } from '@/compositions/helper'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import { useNotificationsStore } from '@/stores/notificationStore'
import FooterComponent from '@/components/FooterComponent.vue'
import * as zod from 'zod';
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';

const userStore = useUserStore()
const notificationsStore = useNotificationsStore()
const router = useRouter()
const logo = ref<string>(blankHomeLogo)

const getTravelIdentifier = async () => {
  await router.isReady()
  const found = router.currentRoute.value.params.slug ?? router.currentRoute.value.params.id ?? undefined
  return Array.isArray(found) ? found[0] : found
}

let brandLoaded = false
onMounted(async () => {
  setTimeout(() => {
    if (!brandLoaded) {
      logo.value = defaultLogo
      console.log('Brand logo not loaded, using default logo.')
    }
  }, 150); // Déclenchement à 150ms si pas de retour du logo

  const identifier = await getTravelIdentifier()
  if (!identifier || identifier === 'login' || identifier === 'invitation') {
    brandLoaded = true
    logo.value = defaultLogo
    return
  }

  const response = await travelApi.getTravelBranding(identifier).catch(() => {brandLoaded = true; logo.value = defaultLogo})
  if (response?.data.logoKey) {
    logo.value = getPictureUrl(response.data.logoKey)
    brandLoaded = true
  }
})

const loginMode = ref<'link' | 'code' | 'password'>('code')
const codeSent = ref<boolean>(false)
const currentLogin = ref<string|undefined>()
const canLogBySMS = ref<boolean>(false)
const canLogByEmail = ref<boolean>(false)

const checkCanLogBySMS = async () => {
  if(currentLogin.value) {
      canLogBySMS.value = await userApi.canLogBySMS(currentLogin.value).then(response => response.data).catch(() => false)
  } else {
    canLogBySMS.value = false
  }
}

const checkCanLogByEmail = async () => {
  if(currentLogin.value) {
      canLogByEmail.value = await userApi.canLogByEmail(currentLogin.value).then(response => response.data).catch(() => false)
  } else {
    canLogByEmail.value = false
  }
}

const codeInput = useTemplateRef('code-input')

const schema = computed(() => toTypedSchema(zod.object({
  login: zod.string({message: 'Veuillez entrer votre adresse email'})
    .email('Email ou numéro de téléphone invalide')
    .min(1, 'Veuillez entrer votre adresse email ou votre numéro de téléphone')
    .or(zod.string()
      .min(1, 'Veuillez entrer votre adresse email ou votre numéro de téléphone')
      .regex(/^(?:\+33[\s.-]?|0)[1-9](?:[\s.-]?\d{2}){4}$/, 'Numéro de téléphone invalide')),
  password: zod.string().nullish().refine((val) => loginMode.value !== 'password' || (val && val.length > 0), {message: "Veuillez entrer votre mot de passe"}),
  code: zod.number().nullish().refine((val) => loginMode.value !== 'code' || !codeSent.value || (val !== null && val !== undefined), {message: "Veuillez entrer le code de connexion" }),
})))

const {
  handleSubmit,
  isSubmitting,
  resetForm,
  values: formValues
} = useForm({
  validationSchema: schema,
});

const clearCode = () => {
  resetForm({values: {...formValues, code: null}});
}

const changeMode = (mode: 'link' | 'code' | 'password') => {
  loginMode.value = mode
  codeSent.value = false
}

const sendSMS = handleSubmit(async values =>
{
  return userApi.sendSMSLoginCode(values.login).then((response) =>
  {
    if (response.status === 200) {
      notificationsStore.notifySuccess('🚀 Code de connexion en route ! Vérifiez vos SMS pour embarquer dans l\'aventure.',undefined, undefined ,true);
      codeSent.value = true;
      clearCode();
      setTimeout(() => {
        codeInput.value?.focus()
      }, 100);
    } else {
      notificationsStore.notifyError('Une erreur est survenue','Impossible d\'envoyer le code de connexion. Veuillez réessayer plus tard.', undefined, true);
    }
  }).catch((error: Error) => {
    notificationsStore.notifyError('Une erreur est survenue',error.message, undefined, true);
    console.error('Error sending login code:', error)
  });
},(result) => {
    const errors = Object.keys(result.errors)
    .map((key:string) => {
      return result.errors[key as keyof typeof result.errors]
    });

    notificationsStore.notifyError(errors.slice(0, 5).join('<br>'), undefined, undefined, true);
})

const sendEmail = handleSubmit(async values =>
{
  return userApi.sendEmailLoginCode(values.login).then((response) => {
      if (response.status === 200) {
        notificationsStore.notifySuccess('🚀 Code de connexion en route ! Vérifiez votre boîte mail pour embarquer dans l\'aventure.',undefined, undefined ,true);
        codeSent.value = true;
        clearCode();
        setTimeout(() => {
          codeInput.value?.focus()
        }, 100);
      } else {
        notificationsStore.notifyError('Une erreur est survenue','Impossible d\'envoyer le code de connexion. Veuillez réessayer plus tard.', undefined, true);
      }
    }).catch((error: Error) => {
      notificationsStore.notifyError('Une erreur est survenue',error.message, undefined, true);
      console.error('Error sending login code:', error)
    });
},(result) => {
    const errors = Object.keys(result.errors)
    .map((key:string) => {
      return result.errors[key as keyof typeof result.errors]
    });

    notificationsStore.notifyError(errors.slice(0, 5).join('<br>'), undefined, undefined, true);
})

const sendLink = handleSubmit(async values =>
{
  return userApi.sendLoginLink(values.login).then((response) => {
      if (response.status === 200) {
        notificationsStore.notifySuccess('🚀 Lien de connexion en route ! Vérifiez votre boîte mail pour embarquer dans l\'aventure.', undefined, undefined, true);
      } else {
        notificationsStore.notifyError('Une erreur est survenue','Impossible d\'envoyer le lien de connexion. Veuillez réessayer plus tard.', undefined, true);
      }
    }).catch((error: Error) => {
      notificationsStore.notifyError('Une erreur est survenue', error.message, undefined, true);
      console.error('Error sending login link', error)
    });
},(result) => {
    const errors = Object.keys(result.errors)
    .map((key:string) => {
      return result.errors[key as keyof typeof result.errors]
    });

    notificationsStore.notifyError(errors.slice(0, 5).join('<br>'), undefined, undefined, true);
})

const loggin = async (mode: 'code' | 'password') => {
  return await handleSubmit(async values => {
    if(mode === 'code') {
      return userApi.getMe({ login: values.login, password: values.code?.toString()??'' }).then((response) => {
        if (response.status === 200) {
          userStore.setConnectedUser(response.data);
        } else {
          clearCode();
        }
      }).catch(() => {
        clearCode();
        notificationsStore.notifyError('Le code entré est incorrect','Veuillez vérifier le code reçu et réessayer.', undefined, true);
        setTimeout(() => {
          codeInput.value?.focus()
        }, 100);
      });
    } else {
      return userApi.getMe({ login: values.login, password: values.password??'' }).then((response) => {
        if (response.status === 200) {
          userStore.setConnectedUser(response.data);
        } else {
          clearCode();
        }
      }).catch(() => {
        clearCode();
        setTimeout(() => {
          codeInput.value?.focus()
        }, 100);
        notificationsStore.notifyError('Email ou mot de passe incorrect','Veuillez vérifier vos identifiants et réessayer.', undefined, true);
      });
    }
  },(result) => {
      const errors = Object.keys(result.errors)
      .map((key:string) => {
        return result.errors[key as keyof typeof result.errors]
      });

      notificationsStore.notifyError(errors.slice(0, 5).join('<br>'), undefined, undefined, true);
  })()
}
</script>
